export const headerAboutUsAnchor = {
  whoWeAre: 'who-we-are',
};
